import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerProps,
  Typography,
  Stack,
} from '@cast/design-system';
import { Search, SearchProvider } from '@cast/shared-search-ui';

import { DrawerContent } from 'components/drawer/ds';
import { useClusterListRowModels } from 'features-op/dashboard/hooks/useClusterListRowModels';

import { notFoundClustersSearchCriteria } from './criteria';
import { NotFoundClustersTable } from './NotFoundClustersTable';

export const NotFoundClustersDrawer = (props: DrawerProps) => {
  const { notFoundClusters } = useClusterListRowModels();

  return (
    <Drawer testId="not-found-clusters-drawer" size="xxlarge" {...props}>
      <DrawerHeader />
      <DrawerBody>
        <DrawerContent>
          <Stack gap={24} height="100%">
            <Typography
              variant="h5"
              data-testid="not-found-clusters-drawer-title"
            >
              Clusters not found
            </Typography>

            <SearchProvider
              data={notFoundClusters}
              criteria={notFoundClustersSearchCriteria}
              urlKey="not-found-clusters"
            >
              <Search
                testId="not-found-clusters-search"
                placeholder="Search for a column name"
              />
              <NotFoundClustersTable />
            </SearchProvider>
          </Stack>
        </DrawerContent>
      </DrawerBody>
    </Drawer>
  );
};
